import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { AutoComplete } from 'primereact/autocomplete';
import { Message } from 'primereact/message';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { CmrDropdownField, CmrInputField, errorCorreo } from "../../CotizacionModificacionRuta/cmrShared";

const PasoInformacionBasica = ({
                                   nombreCotizacion,
                                   setNombreCotizacion,
                                   clienteSeleccionado,
                                   tickets,
                                   ticketSeleccionado,
                                   setClienteSeleccionado,
                                   setTicketSeleccionado,
                                   fechaInicial,
                                   setFechaInicial,
                                   fechaFinal,
                                   setFechaFinal,
                                   clientes,
                                   correo,
                                   setCorreo,
                                   tipoUnidad,
                                   setTipoUnidad,
                                   tiposVehiculo,
                                   tipoRuta,
                                   setTipoRuta,
                                   tiposServicio,
                                   esFija,
                                   setEsFija,
                                   caracteristicasUnidad,
                                   setCaracteristicasUnidad,
                                   modoEdicion
                               }) => {

    const [mostrarMasVehiculos, setMostrarMasVehiculos] = useState(false);
    const [visibleDetalleTicket, setVisibleDetalleTicket] = useState(false);


    const clientesCatalog = { data: clientes, loading: false, error: null };
    const ticketsCatalog  = { data: tickets,  loading: false, error: null };

    const toggleCaracteristica = (campo, valor) => {
        setCaracteristicasUnidad(prev => ({
            ...prev,
            [campo]: valor
        }));
    };


    /**
     * Selecciona un cliente por ID
     * @param {number|string} clienteId
     */
    const seleccionarCliente = (clienteId) => {
        const resultado = clientes.find(
            (cliente) => cliente.id === clienteId
        );

        setClienteSeleccionado(resultado ?? null);
    };

    /**
     * Selecciona un ticket por ID
     * @param {number|string} ticketId
     */
    const seleccionarTicket = (ticketId) => {
        if (!tickets?.length) return;

        const resultado = tickets.find(
            (ticket) => ticket.id === ticketId
        );

        setTicketSeleccionado(resultado ?? null);
    };


    const severidadEstado = (estado) => {
        const mapa = {
            urgente: 'danger',
            alta: 'warning',
            media: 'secondary',
            baja: 'info',
        };
        return mapa[estado?.toLowerCase()] ?? null;
    };

    return (
        <Card className="paso-card">
            {/* Mensaje de bienvenida */}
            <Message
                severity="info"
                className="mb-4"
                content={
                    <div className="flex align-items-center gap-3">
                        <i className="pi pi-info-circle" style={{ fontSize: '1.5rem' }}></i>
                        <div>
                            <strong>Paso 1: Información básica</strong>
                            <p className="m-0 mt-1" style={{ fontSize: '0.9rem' }}>
                                Comencemos con los datos principales de la cotización
                            </p>
                        </div>
                    </div>
                }
            />

            <div className="grid">
                {/* Cliente */}
                <div className="col-12 md:col-4">
                    <CmrDropdownField
                        label="Cliente"
                        required
                        tooltip="Seleccione el cliente para quien se creará esta cotización"
                        helpText="Escriba para buscar o haga clic en la flecha para ver todos"
                        helpIcon="pi-search"
                        catalog={clientesCatalog}
                        value={clienteSeleccionado?.id}
                        onChange={(e) => seleccionarCliente(e.value)}
                        placeholder="Buscar cliente por nombre..."
                        filter
                    />
                </div>

                {/* Ticket */}
                <div className="col-12 md:col-4 grid">
                    <div className="col-10">
                        <CmrDropdownField
                            label="Ticket asociado"
                            required
                            tooltip="Seleccione el ticket relacionado con esta cotización"
                            helpText="Escriba para buscar o haga clic en la flecha para ver todos"
                            helpIcon="pi-search"
                            catalog={ticketsCatalog}
                            value={ticketSeleccionado?.id}
                            onChange={(e) => seleccionarTicket(e.value)}
                            placeholder="Buscar ticket por nombre..."
                            filter
                            disabled={!clienteSeleccionado}
                        />
                    </div>
                    {ticketSeleccionado?.id && (
                        <div className='col-2 mt-3'>
                            <Button
                                icon="pi pi-eye"
                                className="p-button-outlined p-button-secondary mt-2"
                                tooltip="Ver detalle del ticket"
                                tooltipOptions={{ position: 'top' }}
                                onClick={() => setVisibleDetalleTicket(true)}
                                type="button"
                            />
                        </div>
                    )}
                </div>

                {/* Nombre de la cotización */}
                <div className="col-12 md:col-4">
                    <CmrInputField
                        label="Nombre de la ruta"
                        required
                        tooltip="Este nombre se utilizará como el nombre final de la ruta. Ejemplo: 'Cliente - Zona Industrial'."
                        helpText="Escriba el nombre que tendrá la ruta"
                        helpIcon="pi-lightbulb"
                        value={nombreCotizacion}
                        onChange={(e) => setNombreCotizacion(e.target.value)}
                        placeholder="Ej. Cliente - Andares"
                    />
                </div>

                {/* Tipo de ruta */}
                {/*<div className="col-12 md:col-4">
                    <div className="campo-grupo">
                        <label htmlFor="nombreCotizacion" className="campo-label obligatorio">
                            Tipo de ruta
                            <i
                                className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                data-pr-tooltip="Este tipo de ruta se utilizará por defecto en la configuración de la ruta."
                                data-pr-position="right"
                            />
                        </label>
                        <Tooltip target=".tooltip-icon" />

                        <Dropdown
                            value={tipoRuta}
                            options={tiposServicio}
                            onChange={(e) => setTipoRuta(e.value)}
                            placeholder="Seleccione el tipo de servicio"
                            className="w-full"
                            optionLabel="nombre"
                        />

                        <small className="campo-ayuda">
                            <i className="pi pi-lightbulb"></i>
                            Selecciona el tipo de ruta que deseas configurar
                        </small>
                    </div>
                </div>*/}

                {/* Fecha inicial */}
                <div className="col-12 md:col-4">
                    <div className="campo-grupo">
                        <label htmlFor="fechaInicial" className="campo-label obligatorio">
                            Fecha inicial de operación
                            <i
                                className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                data-pr-tooltip="Fecha tentativa en la que comenzará a operar la ruta cotizada"
                                data-pr-position="right"
                            />
                        </label>

                        <Calendar
                            id="fechaInicial"
                            value={fechaInicial}
                            onChange={(e) => setFechaInicial(e.value)}
                            dateFormat="dd/mm/yy"
                            placeholder="Seleccione la fecha de inicio"
                            showIcon
                            icon="pi pi-calendar"
                            minDate={new Date()}
                            className="w-full"
                        />

                        <small className="campo-ayuda">
                            <i className="pi pi-info-circle"></i>
                            Fecha a partir de la cual se activará la ruta
                        </small>
                    </div>
                </div>

                {/* Tipo de ruta */}
                <div className="col-12 md:col-4">
                    <div className="campo-grupo">
                        <label className="campo-label">
                            Es fija
                            <i
                                className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                data-pr-tooltip="Ruta fija: esta ruta no es temporal y permanecerá activa de forma permanente en la cotización."
                                data-pr-position="left"
                            />
                        </label>

                        <div className="tipo-ruta-selector">
                            <div className="flex align-items-center justify-content-between p-1 surface-50 border-round">
                                <div className="flex align-items-center gap-2">
                                    <i className={`pi ${esFija ? 'pi-directions' : 'pi-map-marker'}`}
                                       style={{ fontSize: '1.5rem', color: 'var(--primary-color)' }}>
                                    </i>
                                    <span className="font-semibold">
                                            {esFija ? 'Ruta Fija' : 'Ruta Temporal'}
                                        </span>
                                </div>
                                <InputSwitch
                                    checked={esFija}
                                    onChange={(e) => setEsFija(e.value )}
                                />
                            </div>
                        </div>

                        <Message
                            severity={esFija ? 'info' : 'success'}
                            className="mt-2"
                            text={
                                esFija
                                    ? '🔒 Ruta fija: opera de forma continua.'
                                    : '🕒 Ruta temporal: opera solo por un periodo definido.'
                            }
                        />
                    </div>
                </div>

                {!esFija && (
                    <div className="col-12 md:col-4">
                        <div className="campo-grupo">
                            <label htmlFor="fechaFinal" className="campo-label obligatorio">
                                Fecha final de operación
                                <i
                                    className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                    data-pr-tooltip="Fecha en la que dejará de operar la ruta temporal"
                                    data-pr-position="right"
                                />
                            </label>

                            <Calendar
                                id="fechaFinal"
                                value={fechaFinal}
                                onChange={(e) => setFechaFinal(e.value)}
                                dateFormat="dd/mm/yy"
                                placeholder="Seleccione la fecha final"
                                showIcon
                                icon="pi pi-calendar"
                                minDate={fechaInicial || new Date()}
                                className="w-full"
                            />

                            <small className="campo-ayuda">
                                <i className="pi pi-info-circle"></i>
                                Seleccione hasta qué fecha estará activa la ruta temporal
                            </small>
                        </div>
                    </div>
                )}

                <div className="col-12 md:col-4">
                    <CmrInputField
                        required={true}
                        label="Correo de notificación"
                        tooltip="Correo al que se enviará la cotizacion"
                        placeholder="ejemplo@correo.com"
                        value={correo ?? ""}
                        onChange={(e) => setCorreo(e.target.value)}
                        error={errorCorreo(correo)}
                        helpText="Se enviará un aviso cuando la cotizacion se haya costeado"
                        helpIcon="pi-envelope"
                    />
                </div>
            </div>
            <Divider />

            <div className="campo-grupo">
                <label className="campo-label">
                    Características de la unidad
                    <i
                        className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                        data-pr-tooltip="Seleccione las características adicionales que debe incluir la unidad para esta cotización"
                        data-pr-position="right"
                    />
                </label>

                <small className="campo-ayuda mb-3">
                    <i className="pi pi-check-square"></i>
                    Marque únicamente las opciones requeridas para la unidad
                </small>

                <div className="grid">
                    <div className="col-12 sm:col-6 lg:col-4">
                        <div className="flex align-items-center gap-2 p-3 border-1 surface-border border-round">
                            <Checkbox
                                inputId="direccionAsistida"
                                checked={caracteristicasUnidad?.direccionAsistida || false}
                                onChange={(e) => toggleCaracteristica('direccionAsistida', e.checked)}
                            />
                            <label htmlFor="direccionAsistida" className="cursor-pointer m-0">
                                Direccion Asistida
                            </label>
                        </div>
                    </div>

                    <div className="col-12 sm:col-6 lg:col-4">
                        <div className="flex align-items-center gap-2 p-3 border-1 surface-border border-round">
                            <Checkbox
                                inputId="aireAcondicionado"
                                checked={caracteristicasUnidad?.aireAcondicionado || false}
                                onChange={(e) => toggleCaracteristica('aireAcondicionado', e.checked)}
                            />
                            <label htmlFor="aireAcondicionado" className="cursor-pointer m-0">
                                Aire Acondicionado.
                            </label>
                        </div>
                    </div>

                    <div className="col-12 sm:col-6 lg:col-4">
                        <div className="flex align-items-center gap-2 p-3 border-1 surface-border border-round">
                            <Checkbox
                                inputId="aforo"
                                checked={caracteristicasUnidad?.aforo || false}
                                onChange={(e) => toggleCaracteristica('aforo', e.checked)}
                            />
                            <label htmlFor="aforo" className="cursor-pointer m-0">
                                Aforo
                            </label>
                        </div>
                    </div>

                    <div className="col-12 sm:col-6 lg:col-4">
                        <div className="flex align-items-center gap-2 p-3 border-1 surface-border border-round">
                            <Checkbox
                                inputId="camaraReversa"
                                checked={caracteristicasUnidad?.camaraReversa || false}
                                onChange={(e) => toggleCaracteristica('camaraReversa', e.checked)}
                            />
                            <label htmlFor="camaraReversa" className="cursor-pointer m-0">
                                Cámara Reversa
                            </label>
                        </div>
                    </div>

                    <div className="col-12 sm:col-6 lg:col-4">
                        <div className="flex align-items-center gap-2 p-3 border-1 surface-border border-round">
                            <Checkbox
                                inputId="sensorFatiga"
                                checked={caracteristicasUnidad?.sensorFatiga || false}
                                onChange={(e) => toggleCaracteristica('sensorFatiga', e.checked)}
                            />
                            <label htmlFor="sensorFatiga" className="cursor-pointer m-0">
                                Sensor Fatiga
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            {/* Sección de tipo de vehículo a nivel de ruta */}
            {tiposVehiculo && (
                <>
                    <Divider />

                    <div className="campo-grupo">
                        <label className="campo-label obligatorio">
                            Tipo de unidad para la ruta
                            <i
                                className="pi pi-question-circle ml-2 cursor-pointer tooltip-icon"
                                data-pr-tooltip="Seleccione el tipo de vehículo que operará en esta ruta. Aplica para todos los turnos configurados."
                                data-pr-position="right"
                            />
                        </label>

                        <small className="campo-ayuda mb-3">
                            <i className="pi pi-car"></i>
                            El vehículo seleccionado se asignará a todos los turnos de esta ruta
                        </small>

                        {/* Vehículos comunes */}
                        <div className="grid">
                            {tiposVehiculo.vehiculosComunes.map((vehiculo) => (
                                <div key={vehiculo.valor} className="col-12 sm:col-6 lg:col-3">
                                    <div
                                        className={`vehiculo-card ${tipoUnidad === vehiculo.valor ? 'seleccionado' : ''}`}
                                        onClick={() => setTipoUnidad(vehiculo.valor)}
                                    >
                                        <div className="flex justify-content-between align-items-start mb-2">
                                            <i className={`pi ${vehiculo.icono}`} style={{ fontSize: '2rem', color: 'var(--primary-color)' }}></i>
                                            {tipoUnidad === vehiculo.valor && (
                                                <i className="pi pi-check-circle" style={{ color: 'var(--primary-color)', fontSize: '1.2rem' }}></i>
                                            )}
                                        </div>
                                        <h4 className="m-0 mb-1">{vehiculo.nombre}</h4>
                                        <p className="m-0 text-sm text-600">{vehiculo.capacidad}</p>
                                        <small className="text-xs text-500">{vehiculo.descripcion}</small>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Botón para mostrar más vehículos */}
                        {!mostrarMasVehiculos && (
                            <Button
                                label="Ver más opciones de vehículos"
                                icon="pi pi-angle-down"
                                onClick={() => setMostrarMasVehiculos(true)}
                                className="p-button-text w-full mt-3"
                            />
                        )}

                        {/* Vehículos adicionales */}
                        {mostrarMasVehiculos && (
                            <>
                                <Divider />
                                <h4 className="mt-3 mb-3">Más opciones</h4>
                                <div className="grid">
                                    {tiposVehiculo.vehiculosAdicionales.map((vehiculo) => (
                                        <div key={vehiculo.valor} className="col-12 sm:col-6 lg:col-3">
                                            <div
                                                className={`vehiculo-card-simple ${tipoUnidad === vehiculo.valor ? 'seleccionado' : ''}`}
                                                onClick={() => setTipoUnidad(vehiculo.valor)}
                                            >
                                                <div className="flex align-items-center gap-2">
                                                    <i className={`pi ${vehiculo.icono}`} style={{ fontSize: '1.5rem', color: 'var(--primary-color)' }}></i>
                                                    <div className="flex-1">
                                                        <div className="font-semibold">{vehiculo.nombre}</div>
                                                        <small className="text-500">{vehiculo.capacidad}</small>
                                                    </div>
                                                    {tipoUnidad === vehiculo.valor && (
                                                        <i className="pi pi-check-circle" style={{ color: 'var(--primary-color)' }}></i>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <Button
                                    label="Ocultar opciones adicionales"
                                    icon="pi pi-angle-up"
                                    onClick={() => setMostrarMasVehiculos(false)}
                                    className="p-button-text w-full mt-2"
                                />
                            </>
                        )}
                    </div>
                </>
            )}

            {/* Información adicional */}
            <div className="col-12 mt-4">
                <Message
                    severity="success"
                    className="campo-info-extra"
                    content={
                        <div className="flex gap-3">
                            <i className="pi pi-check-circle" style={{ fontSize: '1.2rem' }}></i>
                            <div style={{ flex: 1 }}>
                                <strong>¿Por qué necesitamos esta información?</strong>
                                <ul className="mt-2 mb-0 pl-3" style={{ fontSize: '0.9rem' }}>
                                    <li>El <strong>cliente</strong> permite personalizar tarifas y condiciones</li>
                                    <li>El <strong>ticket</strong> permite consultar fácilmente su estatus y seguimiento.</li>
                                    <li>El <strong>nombre</strong> le ayudará a encontrar la cotización rápidamente</li>
                                    <li>La <strong>unidad</strong> define el tipo de vehículo que operará en toda la ruta</li>
                                </ul>
                            </div>
                        </div>
                    }
                />
            </div>
            {/* Dialog detalle del ticket */}
            <Dialog
                header={
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-ticket text-primary" />
                        <span>Detalle del Ticket</span>
                    </div>
                }
                visible={visibleDetalleTicket}
                onHide={() => setVisibleDetalleTicket(false)}
                style={{ width: '480px' }}
                breakpoints={{ '768px': '95vw' }}
                dismissableMask
            >
                {ticketSeleccionado && (
                    <div className="flex flex-column gap-3">

                        <div className="flex flex-column gap-1">
                            <span className="text-xs text-500 font-medium uppercase">Nombre</span>
                            <span className="font-medium">{ticketSeleccionado.nombre}</span>
                        </div>

                        <Divider className="my-1" />

                        <div className="flex flex-column gap-1">
                            <span className="text-xs text-500 font-medium uppercase">Estado</span>
                            <Tag
                                value={ticketSeleccionado.prioridad}
                                severity={severidadEstado(ticketSeleccionado.prioridad)}
                            />
                        </div>

                        <div className="flex flex-column gap-1">
                            <span className="text-xs text-500 font-medium uppercase">Descripción</span>
                            <span className="text-sm text-700">{ticketSeleccionado.descripcion || '—'}</span>
                        </div>

                        {/* Agrega aquí los campos propios de tu modelo de ticket */}

                    </div>
                )}
            </Dialog>
        </Card>
    );
};

export default PasoInformacionBasica;
